import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { RiMovie2Fill } from 'react-icons/ri';
import { IoCallSharp } from 'react-icons/io5';
import { SlMagicWand } from 'react-icons/sl';
import { MdOutlineCenterFocusStrong } from 'react-icons/md';
import { FaUserShield } from 'react-icons/fa6';
import Logo from '../../assets/logo/inthetechLogo.png';
import '../../styles/core.css';
import './css/menu.css';
import '../../styles/styles.css';
import { useAuth } from '../../auth/AuthContext';

function Menu({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  const { user, logout, remainingTime, fmtTime } = useAuth();

  const role = (user?.role || '').toString().toUpperCase();
  const isAdmin = role === 'ADMIN';
  const canViewChildData = role === 'ADMIN' || role === 'CLINIC';
  const timeStr = remainingTime != null ? fmtTime(remainingTime) : '-';
  const isLow = typeof remainingTime === 'number' && remainingTime <= 120;
  const linkCls = ({ isActive }) => `app-nav-link ${isActive ? 'active' : ''}`;

  const handleLogoutClick = async () => {
    try {
      await logout();
    } finally {
      navigate('/login');
    }
  };

  return (
    <div className={`app-shell ${isCollapsed ? 'is-collapsed' : ''}`}>
      <aside className="app-sidebar">
        <div className="brand-block">
          <Link to="/" className="brand-link" aria-label="메인으로 이동">
            <img src={Logo} alt="InTheTech" />
          </Link>
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => setIsCollapsed(!isCollapsed)}
            aria-label="메뉴 접기"
          >
            <span />
            <span />
          </button>
        </div>

        <nav className="app-nav" aria-label="주요 메뉴">
          {canViewChildData && (
            <div className="nav-group">
              <p className="nav-label">데이터</p>
              <NavLink to="/contentresult" className={linkCls}>
                <SlMagicWand />
                <span>콘텐츠 수행 결과</span>
              </NavLink>
              <NavLink to="/attentionspan" className={linkCls}>
                <MdOutlineCenterFocusStrong />
                <span>주의 집중 분석</span>
              </NavLink>
              <NavLink to="/PS" className={linkCls}>
                <IoCallSharp />
                <span>처방 설정</span>
              </NavLink>
              <NavLink to="/" end className={linkCls}>
                <RiMovie2Fill />
                <span>처방 관리</span>
              </NavLink>
            </div>
          )}

          {['CLINIC', 'ADMIN'].includes(role) && (
            <div className="nav-group">
              <p className="nav-label">계정</p>
              <NavLink to="/clinic/users" className={linkCls}>
                <i className="fas fa-users" />
                <span>아동 계정 관리</span>
              </NavLink>
              <NavLink to="/clinic/protectors" className={linkCls}>
                <i className="fas fa-user-shield" />
                <span>보호자 계정 관리</span>
              </NavLink>
            </div>
          )}

          {isAdmin && (
            <div className="nav-group">
              <p className="nav-label">관리자</p>
              <NavLink to="/admin/auditlogs" className={linkCls}>
                <FaUserShield />
                <span>감사 기록 확인</span>
              </NavLink>
              <NavLink to="/admin/clinics" className={linkCls}>
                <FaUserShield />
                <span>클리닉 계정 관리</span>
              </NavLink>
            </div>
          )}
        </nav>

        <div className="session-panel">
          <span className="session-caption">로그인 계정</span>
          <strong>{user?.name || user?.id || '-'}</strong>
          <small>{role || 'ROLE'}</small>
          <div className={isLow ? 'session-time low' : 'session-time'}>남은 시간 {timeStr}</div>
          {isAdmin && (
            <button type="button" onClick={() => navigate('/admin/password-change')}>
              비밀번호 변경
            </button>
          )}
          <button type="button" className="logout-button" onClick={handleLogoutClick}>
            로그아웃
          </button>
        </div>
      </aside>

      <section className="app-main">
        <header className="app-topbar">
          <div>
            <p>AR Teacher Console</p>
            <h1>아동 데이터 관리</h1>
          </div>
          <div className="topbar-status">
            <span className="status-dot" />
            <span>{role || 'GUEST'}</span>
          </div>
        </header>
        <main className="app-content">{children}</main>
      </section>
    </div>
  );
}

export default Menu;
